import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section1 .swiper", {
    speed:500,
    effect: "fade",
    fadeEffect:{
        crossFade:true,
    },
    watchSlidesProgress:true,
    pagination: {
        el: ".section1 .swiper-pagination",
        type: "progressbar",
    },
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
    },
});

$(".table-nav li").eq(0).addClass("active");
$(".table-content .table").eq(0).addClass("active"); 

$(".table-nav li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".table-content .table").eq(index).addClass("active").siblings().removeClass("active");
})
